import { IconEdit, IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import IconButton from '../../../components/Buttons/IconButton';

const EditIssueModal = ({ issueData, callback }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const submit = async () => {
        if (document.getElementById("issue").value) {
            let postData = {
                "issueId": issueData?._id,
                "issue": document.getElementById("issue").value
            }
            let resp = await postApi(postData, urlApi.updateIssue);
            if (resp.responseCode === 200) {
                toast.success(resp.message);
                if (callback) {
                    callback();
                }
                handleClose();
            } else {
                toast.error(resp.message);
            }
        } else {
            toast.error("Please enter Issue");
        }
    }

    return (
        <>
            <IconButton onClickFunction={handleShow} icon={<IconEdit size={20} />} />
            <Modal show={show} onHide={handleClose} >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold"> Update Issue Topic</p>
                        <IconX className='cursor-pointer' color='white' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="flex flex-col gap-1">
                        <label htmlFor="issue" className='font-medium'>Issue</label>
                        <input type="text" id='issue' placeholder="Issue" defaultValue={issueData?.issue} className='p-2 text-sm rounded-xl bg-transparent border-2 border-[var(--light-text)]' />
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='px-4 py-1 bg-[var(--secondary)] text-white text-sm font-semibold rounded-lg' onClick={handleClose}>Cancel</button>
                        <button className='px-4 py-1 bg-[var(--secondary-gradient-1)] text-white text-sm font-semibold rounded-lg' onClick={() => submit()}>Submit</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default EditIssueModal